import { useAppSelector } from '../../app/hooks';
import { selectConsumerInputNeededAction } from '../../app/slices/session.slice';
import BankSelectionStep from '../bank-selection/BankSelectionStep';
import RedirectionStep from '../redirection/RedirectionStep';
import AccountSelectionStep from '../account-selection/AccountSelectionStep';
import FormStep from '../form/FormStep';

const ConsumerInputNeededRouter = () => {
	const action = useAppSelector(selectConsumerInputNeededAction);
	switch (action) {
		case 'bank_selection':
			return <BankSelectionStep />;
		case 'redirect':
			return <RedirectionStep />;
		case 'account_selection':
			return <AccountSelectionStep />;
		case 'form':
			return <FormStep />;
		default:
			throw new Error(`Consumer input needed action: ${action} not supported`);
	}
};

export default ConsumerInputNeededRouter;
